import { RouteConfig } from 'vue-router';

import { Errors } from '@/enums/errors.enum';
import { PublicSettings } from '@/enums/publicSettings.enum';
import store from '@/store/store';
import { config } from '@/utils/config';

export const registerRoute: RouteConfig = {
  path: '/register/:type?/:token?',
  name: 'register',
  component: () => import(/* webpackChunkName: "Register" */ '@/views/startRoute/Register.vue'),
  beforeEnter: (to, from, next) => {
    if (config.loginDisabled) {
      return;
    }

    store.dispatch('setting/findPublic', { code: PublicSettings.GDPR_POLICY }).then(setting => {
      if (setting) {
        return next();
      }
      store.dispatch('notifyError', { title: Errors.GDPR_CANNOT_GET });
    });
  }
};
